module.exports = __webpack_public_path__ + "static/media/cm.0ceaad18.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/cm.svg
// module id = 2066
// module chunks = 0